import React from "react";
import { Stars } from "./Stars";
import { SHORT_TESTIMONIALS } from "../lib/data";
export function ShortTestimonials() {
  return <section className="px-4 pt-12" data-id="element-181" data-mp="2z6djexxs3n67">
      <div className="mx-auto max-w-md" data-id="element-182" data-mp="3d4aetr0hxnja">
        <h2 className="text-center font-display text-xl font-extrabold text-slate-900" data-id="element-183" data-mp="3d53hafsf9qvm">
          Lo que dicen fisios como tú
        </h2>
        <div className="mt-5 space-y-2.5" data-id="element-184" data-mp="387k47j7gnk59">
          {SHORT_TESTIMONIALS.map(t => <div key={t.name} className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-white p-3 shadow-sm" data-id="element-185" data-mp="3n0djp4mqg09x">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 font-display text-sm font-bold text-slate-600" data-id="element-186" data-mp="3vti6cxj6iuts">
                {t.name.charAt(0)}
              </div>
              <div className="min-w-0" data-id="element-187" data-mp="9o3enuhai8f9">
                <div className="flex flex-wrap items-center gap-x-2" data-id="element-188" data-mp="4oig3l618232">
                  <span className="text-sm font-bold text-slate-800" data-id="element-189" data-mp="4qbmczcqgkaj">{t.name}</span>
                  <span className="text-xs text-slate-400" data-id="element-190" data-mp="2twwfeuch5qea">
                    {t.age} · {t.city}
                  </span>
                  <Stars size={12} data-id="element-191" data-mp="2ywscsaqo2jkv" />
                </div>
                <p className="mt-0.5 text-[13.5px] leading-snug text-slate-600" data-id="element-192" data-mp="33sprkcma7hvj">
                  "{t.text}"
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}